import { render, staticRenderFns } from "./serviceTag.vue?vue&type=template&id=0c27f0dc&scoped=true&"
import script from "./serviceTag.vue?vue&type=script&lang=js&"
export * from "./serviceTag.vue?vue&type=script&lang=js&"
import style0 from "./serviceTag.vue?vue&type=style&index=0&id=0c27f0dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27f0dc",
  null
  
)

export default component.exports